import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs,validationSchema } from '@/entities/Notifications/NotificationsFormInputs'

const Notifications = {
	Plural: 'Notifications',
	Single: 'Notification',
	Inputs: Inputs,	
	FormWithImage: true,
	Relationships: [
		
	],
	ValidationSchema: validationSchema,
	SaveCallBack: (id) =>{ 
		//router.push(`/leagues/edit/${id}`)
	}
};

export default Notifications;
